import React from 'react';

import {LLMRole} from 'graphql-client/__generated/graphqlGlobalTypes';
import {assertNever} from 'util/Types';

import {ChatMessageBubble} from './ChatMessageBubble';
import {ClientPendingVoiceTranscript} from './MessageTypes';

export interface ChatPendingVoiceTranscriptBubbleProps {
  event: ClientPendingVoiceTranscript;
}

const ChatPendingVoiceTranscriptBubble = React.forwardRef<
  HTMLDivElement,
  ChatPendingVoiceTranscriptBubbleProps
>(({event}, ref): JSX.Element => {
  switch (event.role) {
    case LLMRole.USER:
      return (
        <ChatMessageBubble ref={ref} variant="user_message" toolbar={null} faded={true}>
          Waiting for your voice transcript…
        </ChatMessageBubble>
      );
    case LLMRole.ASSISTANT:
      return (
        <ChatMessageBubble ref={ref} variant="reply" toolbar={null} faded={true}>
          Waiting for the assistant&apos;s voice transcript…
        </ChatMessageBubble>
      );
    default:
      throw new Error(`Unknown Voice transcript role: ${assertNever(event.role)}`);
  }
});

export default ChatPendingVoiceTranscriptBubble;
